import { ContactPageContent } from '../../components/pages/contact';
import Layout from '../../components/shared/Layout';
import { usePageVistTracker } from '../../hooks/usePageVistTracker';

const Contact: React.FC = () => {
  usePageVistTracker();

  return (
    <Layout description="Contact Support or give feedback." pageTitle="Contact Us">
      <ContactPageContent />
    </Layout>
  );
};

export default Contact;
